<template>
   <div class="row">
      <div class="col-sm-12 col-md-8 col-lg-6 col-centered create-report-card">

         <div class="card p-4" v-if="!utils.is_invitation_sent">
            <div class="col-centered text-center">
               <div class="custom-title pt-7">
                  Signatory emails
               </div>
               <div class="custom-subheading pt-3">
                  Please provide the signatories email addresses. We will send them the pdf to sign.
               </div>
               <img alt="icon" class="pt-1" src="/media/misc/signatory_email.png" width="130"/>
            </div>
            <div class="container">
               <div class="row m-auto">
                  <div class="col-12">
                     <div class="form-body p-10 mt-7 position-relative">
                        <div class="position-relative">
                           <label class="font-weight-bold" style="font-size: 11px;">Email</label>

                           <template v-for="(f, i) in $v.swap.emails.$each.$iter">
                              <div :key="i" class="s-email-container mt-3">
                                 <input class="url-input-wrapper" placeholder="Enter signatory email"
                                        style="padding-left: 15px;" v-model.trim="f.email.$model" @input="onInput"/>

                                 <button @click="removeMailField(i)" class="delete-email-field" v-if="i >= 1">
                                    <i class="mdi mdi-close-circle-outline"
                                       style="color: #ff1e0ebd;font-size: 25px;"></i>
                                 </button>

                                 <div class="mb-5" v-if="$v.swap.$error">
                                    <div class="error" v-if="!f.email.required">Name is required.</div>
                                    <div class="error" v-if="!f.email.email">Email not valid.</div>
                                 </div>
                              </div>
                           </template>

                           <button @click="addMailField" class="s-add-email pt-5 mt-5" v-if="swap.emails.length <= 2">
                              Add Email
                           </button>
                        </div>

                        <p class="pt-8" style="font-family: Exo2-Regular;font-size: 13px;"
                           v-if="swap.emails.length > 1">
                           Invite <span class="s-emails-added-span" style="font-family: 'Exo 2'">{{ swap.emails.length }} people</span>
                           to sign this documents
                        </p>
                        <div class="text-right pt-10 mb-10">
                           <button @click="sendInvitation"
                                   :class="{'disabled': !utils.emails_field_valid}"
                                   class="btn btn-success font-weight-bold custom-btn-create-report px-6 py-3"
                                   ref="invite_btn">
                              Send Invitation
                           </button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div class="card p-4 pb-9" v-else>
            <div class="col-centered text-center">
               <img alt="icon" class="pt-9" src="/media/misc/mail_sent.png" width="130"/>
               <div class="custom-title-min-width pt-7">
                  Email has been successfully sent to all signatories
               </div>
            </div>
            <div class="p-10 ml-10 mr-10 text-muted text-center">
               We will notify you once the documents has been signed by the signatories.
            </div>
            <div class="text-center mb-10">
               <button @click="createAnotherReport"
                       class="btn btn-success font-weight-bold custom-btn-create-report px-6 py-3">
                  Create Another Report
               </button>
            </div>
         </div>

      </div>
   </div>
</template>

<script>

   import { validationMixin } from 'vuelidate';
   import {required, email} from 'vuelidate/lib/validators';
   import generalMixin from '../../core/mixins/generalMixin';
   import {
      CHANGE_COMPONENT
   } from '../../core/store/modules/report';
   import {
      SIGNPROOF_INVITE_SIGNATORY,
      SIGNPROOF_SAVE_INVITATION_DATA
   } from '../../core/store/modules/report.signproof';

   export default {
      name: "Report.Signproof.Invite",
      data() {
         return {
            utils: {
               is_btn_loading: false,
               emails_field_valid: false,
               is_invitation_sent: false,
            },
            swap: {
               emails: [
                  {email: ''}
               ]
            }
         }
      },
      validations: {
         swap: {
            emails: {
               $each: {
                  email: {
                     required,
                     email
                  }
               }
            }
         }
      },
      mixins: [generalMixin, validationMixin],
      methods: {
         onInput() {
            this.isEmailsValid();
         },
         isEmailsValid() {
            let errors = [];
            this.swap.emails.forEach((e) => {
               if(e.email.length !== 0) {
                  if(!this.$v.swap.emails.$error) {
                     errors.push(1);
                  }
               }
               errors.push(0);
            });
            this.utils.emails_field_valid = errors.reduce((a, b) => a + b) === this.swap.emails.length;
         },
         addMailField() {
            this.swap.emails.push({email: ''});
            this.isEmailsValid();
         },
         removeMailField(position) {
            this.swap.emails.splice(position, 1);
            this.isEmailsValid();
         },
         sendInvitation() {

            const btn = this.$refs["invite_btn"];

            this.addSpinnerLight(btn);

            let emails = this.swap.emails.map((e) => e.email);

            Promise.all([
               this.$store.dispatch(SIGNPROOF_INVITE_SIGNATORY, emails)
                   .then(() => this.$store.dispatch(SIGNPROOF_SAVE_INVITATION_DATA))
            ]).then((res) => {
               console.log(res);
               this.removeSpinner(btn);
               this.utils.is_invitation_sent = true;
            }).catch((e) => {
               console.log(e);
               this.removeSpinner(btn);
               this.utils.is_btn_loading = false;
            });
         },
         //
         createAnotherReport() {
            this.$store.dispatch(CHANGE_COMPONENT, 'appReportSignproofInit');
         }
      }
   }
</script>

<style scoped>
   .s-email-container {
      position: relative;
      background: #ffffff;
      border: 1px solid #c5cdd4;
      height: 45px;
      border-radius: 8px;
   }

   .s-add-email {
      cursor: pointer;
      border-radius: 50px;
      height: 35px;
      font-weight: 500 !important;
      line-height: 0px;
      width: 80px;
      font-size: 11px;
      text-align: center;
      margin-top: 10px !important;
      color: #82037e;
      padding: 14px 0;
      background-color: #82037e17;
      border: 1px solid #82037e0d;
   }

   .delete-email-field {
      cursor: pointer;
      position: absolute;
      bottom: 0px;
      right: -30px;
   }

   .s-emails-added-span {
      cursor: pointer;
      border-radius: 4px;
      height: 29px;
      padding: 2px 8px 4px;
      font-weight: 500 !important;
      line-height: 25px;
      width: 80px;
      font-size: 11px;
      text-align: center;
      margin-top: 10px;
      color: #2e3c4e;
      background-color: #06cfef29;
      border: 1px solid #06cfef1a;
      font-family: Exo2-SemiBold;
   }
</style>